import logService from '../wss/logService3';

/**
 * Generic key-value cache.
 * Stores and retrieves values by key.
 * Domain-specific operations (addOrUpdate, removeFromNode, etc.) belong in subclasses.
 */
export default class CachedDictionary {
    _name = 'CachedDictionary';
    _data = {};

    /**
     * Guards against null _data. Logs the calling method name if triggered.
     */
    _check = (method) => {
        if (!this._data) {
            logService.logError(`${this._name}.${method}: _data is null`);
            this._data = {};
        }
    };

    /**
     * Stores a value under the given key. Acts as both add and update.
     */
    setKey = (key, value) => {
        try {
            this._check('setKey');
            this._data[key] = value;
        } catch (error) {
            logService.logError(`${this._name}.setKey: ${error.message}`);
        }
    };

    /**
     * Returns value for the given key, or null if not found.
     */
    getKey = (key) => {
        try {
            this._check('getKey');
            return this._data[key] ?? null;
        } catch (error) {
            logService.logError(`${this._name}.getKey: ${error.message}`);
            return null;
        }
    };

    /**
     * Returns true if the given key exists.
     */
    hasKey = (key) => {
        try {
            this._check('hasKey');
            return this._data[key] !== undefined;
        } catch (error) {
            logService.logError(`${this._name}.hasKey: ${error.message}`);
            return false;
        }
    };

    /**
     * Returns all known keys.
     */
    getKeys = () => {
        try {
            this._check('getKeys');
            return Object.keys(this._data);
        } catch (error) {
            logService.logError(`${this._name}.getKeys: ${error.message}`);
            return [];
        }
    };

    /**
     * Clears all keys and values.
     */
    clear = () => {
        this._data = {};
    };
}
